import { VulnerableProjectModel } from '@models';

export interface VulnerableProjectsResult {
  foundationVulnerableProjects: VulnerableProjectModel[];
}
